import WhatsAppLink from "./WhatsAppLink.tsx";
import { Image } from "@heroui/react";

export default function Footer() {
  return (
    <footer
      className="bg-gray-800 text-white relative overflow-hidden z-100"
      // ⬇️ ya no usamos backgroundImage; lo dejamos vacío a propósito
      style={{
        // backgroundImage: `url(${footer})`,
        // backgroundPosition: "right center",
      }}
    >
      {/* 🔹 Capa de video como background */}
      <div
        className="absolute inset-0 -z-10 pointer-events-none"
        aria-hidden="true"
      >
        {/* Contenedor para centrar el iframe y cubrir ancho completo */}
        <div className="absolute inset-0 flex items-center justify-center">
          <iframe
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
            // Truco 16:9 que "cubre" el contenedor:
            // - width 100vw / height 56.25vw: cubre ancho del viewport manteniendo 16:9
            // - minHeight 100%: garantiza cubrir la altura del footer
            // - Si el footer es muy bajo, se “recorta” arriba/abajo, mostrando la parte central
            style={{
              width: "100vw",
              height: "56.25vw",      // 9/16 = 0.5625
              minHeight: "100%",
            }}
            src={
              "https://www.youtube.com/embed/a_0AgvcCQ20?autoplay=1&mute=1&loop=1&playlist=a_0AgvcCQ20&controls=0&modestbranding=1&showinfo=0&start=80&end=120"
            }
            title="Vegan Vegetarian Footer Video"
            frameBorder="0"
            allow="autoplay; fullscreen; encrypted-media"
            referrerPolicy="strict-origin-when-cross-origin"
          />
        </div>

        {/* 🔹 Overlay para contraste del texto */}
        <div className="absolute inset-0 bg-black/50" />
      </div>

      {/* 🔹 Contenido del footer (tal cual lo tenías) */}
      <div
        className="w-full min-h-[20rem] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 p-4 sm:p-3 md:p-[16px_13px] relative gap-3 sm:gap-0"
        style={{ zIndex: 1 }}
      >
        <div className="footer-section h-full p-4 sm:p-[19px_34px]">
          <h4 className="font-light mb-4 font-montserrat text-lg">
            NOSOTROS
          </h4>
          <h5 className="text-sm sm:text-base text-justify">
            Vegan Vegetarian somos el reflejo de una vida dedicada a la pasión,
            la disciplina y el amor por la alimentación consciente. en la comida
            vegetariana En este viaje fuimos creando recetas propias, llenas de
            creatividad y autenticidad, que hoy son el corazón de Vegan
            Vegetarian
          </h5>
        </div>

        <div className="footer-section h-full p-4 sm:p-[19px_34px]">
          <h4 className="font-light mb-4 sm:mb-10 text-lg">Riqueza Local</h4>
          <div
            onClick={() =>
              window.open("https://maps.app.goo.gl/uaixct7ZqzwVMW566", "_blank")
            }
            className="mb-4 sm:mb-10 flex hover:cursor-pointer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 384 512"
              className="self-start w-5 sm:w-6 mr-3 sm:mr-7"
              fill="currentColor"
            >
              <path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"></path>
            </svg>
            <h5 className="text-sm sm:text-base">
              Carr. Mérida - Progreso,
              <br />
              Gonzalo Guerrero,
              <br />
              Mérida, Yucatán,
              <br />
              México, C.P. 97115.
            </h5>
          </div>

          <div className="mb-4 sm:mb-10 flex font-semibold">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              className="self-start w-7 sm:w-10 mr-3 sm:mr-7"
              fill="currentColor"
            >
              <path fill="none" d="M0 0h24v24H0z"></path>
              <path d="M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm3.85-4h1.64L21 16l-1.99 1.99A7.512 7.512 0 0 1 16.28 14c-.18-.64-.28-1.31-.28-2s.1-1.36.28-2a7.474 7.474 0 0 1 2.73-3.99L21 8l-1.51 2h-1.64c-.22.63-.35 1.3-.35 2s.13 1.37.35 2z"></path>
            </svg>
            <h5 className="text-sm sm:text-base">
              <WhatsAppLink phoneNumber="+529991268546" displayNumber="(999) 126 8546" />
              <br />
              <WhatsAppLink phoneNumber="+529991370515" displayNumber="(999) 137 0515" />
              <br />
              <WhatsAppLink phoneNumber="+330661880915" displayNumber="(999) 190 0084" />
            </h5>
          </div>
        </div>

        <div className="footer-section h-full p-4 sm:p-[19px_34px]">
          <h4 className="font-light mb-4 sm:mb-10 text-lg">Proximamente en plataformas</h4>
          <div className="mb-4 sm:mb-10 flex flex-col">
            <Image
              onClick={() =>
                window.open(
                  "https://www.ubereats.com/mx/store/vegan-vegetarian/abc123xyz",
                  "_blank"
                )
              }
              src="./vegan/uber.webp"
              alt="Vegan Vegetarian en Uber Eats"
              radius="full"
              className="h-32 ml-5 hover:cursor-pointer"
            />

            <Image
              onClick={() =>
                window.open(
                  "https://www.rappi.com.mx/restaurantes/<nombre-del-negocio>?id=<id-unico>",
                  "_blank"
                )
              }
              src="./vegan/rappi.webp"
              alt="founders"
              radius="full"
              className="h-22 ml-5 hover:cursor-pointer"
            />
          </div>
        </div>

        <div className="footer-section h-full p-4 sm:p-[19px_34px]">
          <h4 className=" mb-4 sm:mb-10 text-lg font-light">HORARIOS</h4>
          <div className="flex text-md sm:text-base">
            <div className="flex flex-col mr-4 sm:mr-10">
              <h5 className="mb-4 sm:mb-8">Lunes a Jueves:</h5>
              <h5 className="mb-4 sm:mb-8">Sabado:</h5>
            </div>
            <div className="flex flex-col font-semibold">
              <h5 className="mb-4 sm:mb-8">Cerrado</h5>
              <h5 className="mb-4 sm:mb-8">12 am a 6 pm</h5>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
